import client from '../api/inventory-request';
import { summarizeRfqInviteNotify } from './rfqInviteNotify';

export { summarizeRfqInviteNotify as summarizeWoInviteNotify };

function vendorIdsFromWo(wo = {}) {
  const payload = wo.payload && typeof wo.payload === 'object' ? wo.payload : {};
  const fromInvited = (wo.invited_vendors || [])
    .map((row) => row?.vendor_id || row?.id)
    .filter(Boolean);
  return (payload.invited_vendor_ids || wo.invited_vendor_ids || fromInvited)
    .filter(Boolean);
}

/**
 * Staff inventory invite mailer for work bids. Body is only vendor_ids.
 * Publish must not fail if this call fails.
 */
export async function notifyWoInvitedVendors(woId, {
  wo: woHint = {},
  vendorIds: vendorIdsHint,
} = {}) {
  const empty = { sent: [], failed: [], url: '' };
  if (!woId) return empty;

  let vendorIds = (vendorIdsHint && vendorIdsHint.length)
    ? vendorIdsHint.filter(Boolean)
    : vendorIdsFromWo(woHint);

  if (!vendorIds.length) {
    try {
      const live = await client.get(`/inventory/work-orders/${woId}/`);
      vendorIds = vendorIdsFromWo({ ...woHint, ...(live || {}) });
    } catch {
      return empty;
    }
  }
  if (!vendorIds.length) return empty;

  const data = await client.post(`/inventory/work-orders/${woId}/vendor-email-invite/`, {
    vendor_ids: vendorIds,
  });
  return {
    sent: Array.isArray(data?.sent) ? data.sent : [],
    failed: Array.isArray(data?.failed) ? data.failed : [],
    url: data?.url || '',
  };
}
